module.exports = __webpack_public_path__ + "img/image9.dc2cc305.png";